module.exports = __webpack_public_path__ + "img/car-33.46ad8144.jpg";